<template>

  <!-- TABLE -->
  <tr v-if="vmode === 'table'"
  :class="{'selected': selected[item.id]}">
    <td class="sticky">
      <v-layout align-center>

        <v-menu v-if="$store.state.settings.debugMode" offset-x open-on-hover>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              color="red"
              v-on="on"
            >
              <v-icon small>mdi-android-debug-bridge</v-icon>
            </v-btn>
          </template>
          <v-card outlined class="elevation-0">
            <v-layout class="backgroundCard pa-2 caption">
              JSON
            </v-layout>
            <div class="c-hr"></div>
            <div class="pa-3">
              <span class="caption">
                {{ item }}
              </span>
            </div>
          </v-card>
        </v-menu>

        <v-btn
        icon
        text
        @click.stop="$emit('checkRow', item)">
          <v-icon :color="selected[item.id] ? 'color1' : ''"> 
            {{ selected[item.id] ? 'check_box' : 'check_box_outline_blank' }}
          </v-icon>
        </v-btn>
        <img class="" src="@/assets/img/illustrations/purse.png" alt="cardboard box" width="25px">
        <transition
        name="slide-x-transition"
        appear
        hide-on-leave
        mode="out-in">
          <v-icon v-if="itemsMeta.newID === item.id" color="color1" style="position: absolute; left: 0px; top: 0px;">mdi-new-box</v-icon>
        </transition>
        <div>
          <div 
          class="caption"
          v-html="highlightedVisualID">
          </div>
          <div 
          class="caption"
          v-html="highlightedID">
          </div>
        </div>
      </v-layout>
    </td>
    <td>
      {{ item.items.length }}
    </td>
    <td>
      {{ item.customer_name }}
    </td>
    <td>
      <c-price :quantity="item.total" labelMode :currency="item.currency">
      </c-price>
    </td>
    <td>
      <div :class="['text-ellipsed']">
      {{ dateFromNow }}
      </div>
      <div class="label">
        {{ humanDate }}
      </div>
    </td>
  </tr>
</template>

<script>

export default {
  props:['item', 'itemsMeta', 'vmode', 'searchTextID', 'selected'],
  data () {
    return {
      hover: false
    }
  },
  computed: {
    highlightedID () {
      var replacedStr = (this.searchTextID || '').trim().split(/\s+/).map(x => x.replace(/[-[\]{}()*+!<=:?.\\^$|#\s,]/g, '\\$&')).join('|')
      replacedStr = this.item.id.toString().replace(new RegExp(replacedStr, 'gi'), '<span class="color1--text font-weight-bold">$&</span>')
      return '<span class="font-weight-regular">' + replacedStr + '</span>'
    },
    highlightedVisualID () {
      var replacedStr = (this.searchTextID || '').trim().split(/\s+/).map(x => x.replace(/[-[\]{}()*+!<=:?.\\^$|#\s,]/g, '\\$&')).join('|')
      replacedStr = (this.item.id_visual || '').toString().replace(new RegExp(replacedStr, 'gi'), '<span class="color1--text font-weight-bold">$&</span>')
      return '<span class="font-weight-regular">' + replacedStr + '</span>'
    },
    humanDate () {
      if (this.$moment.utc(this.item.created_at).isValid()) {
        if (this.vmode === 0) {
          return this.$moment(this.item.created_at).format('ddd D, MMM YYYY, h:mm')
        } else {
          return this.$moment(this.item.created_at).format('DD MMM YYYY, ddd')
        }
      }
      return ''
    },
    dateFromNow () {
      if (this.$moment.utc(this.item.created_at).isValid()) {
        return this.$moment.utc(this.item.created_at).fromNow()
      }
      return ''
    }
  }
}
</script>

<style scoped lang="scss">

</style>